export const AlertVariants = {
  Default: 'DEFAULT',
  Info: 'INFO',
  Positive: 'POSITIVE',
  Negative: 'NEGATIVE',
  Warning: 'WARNING',
  Notice: 'NOTICE',
  Guide: 'GUIDE',
} as const;
export type AlertVariants = (typeof AlertVariants)[keyof typeof AlertVariants];
